import StackTrace from 'stacktrace-js';
import ServerAPI from '../ServerAPI';
// We use the datamodel to add logged in user to the stack trace:
import AppModel from '../DataModel/AppModel';

var callback = function(stackframes) {
  var stacklines = stackframes.map(function(sf) {
    return sf.toString();
  });
  if(AppModel.userInfo) {
    stacklines.unshift("Logged in user:"+AppModel.userInfo.id_customer+"/"+AppModel.userInfo.id);
  }
  ServerAPI.sendStackToServer(stacklines);
};

var errback = function(err) { console.log(err.message); };

window.onerror = function(msg, file, line, col, error) {
    // callback is called with an Array[StackFrame]
    StackTrace.fromError(error).then(callback).catch(errback);
};

// Bluebird promise module seems to capture exceptions, so we also have to
// listen for this event and call the StackTrace handler for those
window.addEventListener("unhandledrejection", function(e) {
    // NOTE: e.preventDefault() must be manually called to prevent the default
    // action which is currently to log the stack trace to console.warn
    //e.preventDefault();
    // (We currently allow both to happen)

    // The e.detail.reason is expected to be an Error object:
    if(e.detail && e.detail.reason && e.detail.reason.constructor === Error) {
      var reason = e.detail.reason;
      StackTrace.fromError(reason).then(callback).catch(errback);
    }
/*
    console.log(reason);
    var lines = [JSON.stringify(reason)]
    if(AppModel.userInfo) {
      lines.unshift("Logged in user:"+AppModel.userInfo.id_customer+"/"+AppModel.userInfo.id);
    }
    ServerAPI.sendStackToServer(lines);
    // See Promise.onPossiblyUnhandledRejection for parameter documentation
    */
});



console.log("Global stack trace catcher installed");
// This is not really useful for anything, the module sets up the global
// error handler when loaded and does not provide any further API
export default {
  callback,
  errback,
  StackTrace
};



/** WEBPACK FOOTER **
 ** ./src/utils/stackTraceCatcher.js
 **/